import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "../contexts/AuthContext";
import { Loader2, Lock } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const u = await login(email.trim().toLowerCase(), password);
      navigate(u.role === "admin" ? "/admin" : "/", { replace: true });
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#f7f7f6] px-4">
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-white border border-[#E5E5E5] rounded-md p-8 space-y-5"
        data-testid="login-form"
      >
        <div>
          <img
            src="/logo-mark.png"
            alt="InvoiceIQ"
            className="w-10 h-10 rounded-sm mb-4"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
          <h1 className="font-display text-2xl font-bold">Welcome back</h1>
          <p className="text-xs text-[#525252] mt-1">
            Sign in to your InvoiceIQ ledger.
          </p>
        </div>
        <div>
          <label className="block eyebrow mb-2">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-[#E5E5E5] rounded-md px-3 py-2.5 text-sm focus:border-[#0A0A0A] focus:outline-none"
            required
            data-testid="login-email"
          />
        </div>
        <div>
          <label className="block eyebrow mb-2">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-[#E5E5E5] rounded-md px-3 py-2.5 text-sm focus:border-[#0A0A0A] focus:outline-none"
            required
            data-testid="login-password"
          />
        </div>
        {error && (
          <div className="text-xs text-[#DC2626] bg-[#FFF0F0] border border-[#FECACA] rounded-sm px-3 py-2" data-testid="login-error">
            {error}
          </div>
        )}
        <button
          type="submit"
          disabled={busy}
          className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-[#0A0A0A] text-white text-sm font-medium rounded-md hover:bg-[#171717] disabled:opacity-50"
          data-testid="login-submit"
        >
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />}
          Sign in
        </button>
        <div className="text-xs text-[#525252] text-center">
          New store?{" "}
          <Link to="/signup" className="text-[#0A0A0A] underline">
            Request access
          </Link>
        </div>
      </form>
    </div>
  );
}
